export const isNotProduction =
  (process.env.REACT_APP_ENV ?? process.env.NODE_SERVER_ENV ?? process.env.NODE_ENV) !== 'production';

export const isNotLocalhost = process.env.NODE_ENV !== 'development';
